import { ISwrConfiguration, useFetch } from 'lib/hooks';
import { useContext, useEffect } from 'react';
import { OnboardingContext } from './context';
import { IAdminOnboardingInfo, OnboardingStep } from './types';

/**
 * Hook to complete an onboarding step when a component is loaded.
 * @param type onboarding step to mark as complete
 */
export const useCompleteOnboardingStep = (type: OnboardingStep) => {
  const { completeStep } = useOnboardingContext();
  useEffect(() => {
    completeStep(type);
  }, []);
};

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);

  if (!context) {
    throw new Error(
      'useOnboardingContext must be used within an OnboardingContextProvider'
    );
  }

  return context;
};

/**
 * Hook to fetch the company's onboarding info.
 * @param options SWR configuration options
 */
export const useOnboardingInfo = (options?: ISwrConfiguration) =>
  useFetch<IAdminOnboardingInfo>('/admin/account/onboarding', options);
